require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 322
 ** module chunks = 1
 **/